import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import BudgetTable from './BudgetTable';
import ActualTable from './ActualTable';
import VarianceTable from './VarianceTable';

import { FTE_DIVISOR } from '../../../store/actions/reports/reportsActions'; 

class GroupCard extends Component {
  render() {
    let budgetScopes = this.props.budgetScopes;

    budgetScopes = budgetScopes.length ? budgetScopes.filter(data => {
      if (data.platform_id === this.props.groupId) {
        return data;
      }
      return false;
    }).map(budgetScope => {
      return budgetScope;
    }) : [];

    let timeEntriesPerBand = this.props.timeEntriesPerBand;
    
    timeEntriesPerBand = timeEntriesPerBand.length ? timeEntriesPerBand.filter(data => {
      if (data.group === this.props.groupId) {
        return data;
      }
      return false;
    }).map(item => {
      return item;
    }) : [];

    return (
      <>
        <Row className="mt-5">
          <Col><b>{this.props.groupLabel}</b></Col>
        </Row>
        <Row>
          <Col xs={4} sm={4} md={4} lg={4} xl={4} className="align-center"><b>BUDGET</b></Col>
          <Col xs={4} sm={4} md={4} lg={4} xl={4} className="align-center"><b className="ml-5">ACTUAL</b></Col>
          <Col xs={4} sm={4} md={4} lg={4} xl={4} className="align-center"><b className="ml-5"> VARIANCE</b></Col>
        </Row>
        <Row>
          <Col xs={4} sm={4} md={4} lg={4} xl={4} className="align-center"> 
            <BudgetTable 
              budgetScopes={budgetScopes} 
              bands={this.props.bands} 
              groupId={this.props.groupId} 
              fteDivisor={FTE_DIVISOR} />
          </Col>
          <Col xs={4} sm={4} md={4} lg={4} xl={4} className="align-center"> 
            <ActualTable budgetScopes={budgetScopes} 
              timeEntriesPerBand={timeEntriesPerBand} 
              groupId={this.props.groupId} 
              fteDivisor={FTE_DIVISOR} />
          </Col>
          <Col xs={4} sm={4} md={4} lg={4} xl={4} className="align-center"> 
            <VarianceTable 
              budgetScopes={budgetScopes} 
              timeEntriesPerBand={timeEntriesPerBand} 
              groupId={this.props.groupId} 
              fteDivisor={FTE_DIVISOR} />
          </Col>
        </Row>
      </>
    )
  }
}

export default GroupCard
